import { useLocalStorage } from '@mantine/hooks';
import { useMobileDetector } from '@zorro/web/ui-utils';
import _noop from 'lodash/noop';
import { ReactNode, createContext, useContext, useState } from 'react';

export type AppLayoutContextProps = {
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
  toggleSearch: () => void;
  isSearchOpen: boolean;
};

export const AppLayoutContext = createContext<AppLayoutContextProps>({
  toggleSidebar: _noop,
  isSidebarOpen: false,
  toggleSearch: _noop,
  isSearchOpen: false,
});

type LoadingOverlayProviderProps = {
  children?: ReactNode;
};

const _AppLayoutContextProvider = ({
  children,
}: LoadingOverlayProviderProps) => {
  const { isMobile } = useMobileDetector();
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

  const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage<boolean>({
    key: 'sidebar-open',
    defaultValue: !isMobile,
  });

  return (
    <AppLayoutContext.Provider
      value={{
        toggleSidebar: () => setIsSidebarOpen((prev) => !prev),
        isSidebarOpen,
        toggleSearch: () => setIsSearchOpen(!isSearchOpen),
        isSearchOpen,
      }}
    >
      {children}
    </AppLayoutContext.Provider>
  );
};

export const AppLayoutContextProvider = ({
  children,
}: LoadingOverlayProviderProps) => {
  if (typeof window === 'undefined') {
    return null;
  }

  return <_AppLayoutContextProvider>{children}</_AppLayoutContextProvider>;
};

export function useAppLayout() {
  return useContext(AppLayoutContext);
}
